import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import Alert from "../../components/Alert";
import constants from "../../constants";
import Subscription from "../../Home/subscription/index";
import Footer from "../footer";
import NavBar from "../nav-bar";
import Pagination from "./pagination";
import style from "./style.module.css";

const NewsPage = () => {
	const [newsFeed, setNewsFeed] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState("");
	const [loading, setLoading] = useState(false);
	const [isDataLoaded, setIsDataLoaded] = useState(false);
	const [alert, setAlert] = useState({
		showing: false,
		type: null,
		message: ""
	});

	const history = useHistory();
	const location = useLocation();
	const newsCardsRef = useRef({});
	const searchParams = new URLSearchParams(location.search);
	const highlightedId = searchParams.get("highlight");

	useEffect(() => {
		const getNewsFeed = async () => {
			try {
				setLoading(true);
				setIsDataLoaded(false); // Reset loading state
				let { data, totalPages } = await axios
					.get(
						`${constants.BASE_URL_3}/newsheadline?page=${currentPage}`
					)
					.then((res) => res.data.data);
				setNewsFeed(data);
				setTotalPages(totalPages);
				setIsDataLoaded(true); // Mark data as loaded
			} catch (error) {
				if (error.response) {
					setAlert({
						...alert,
						showing: true,
						type: "error",
						message:
							error.response.data?.msg ||
							error.response.data?.errors?.[0] ||
							error.response.data?.errors?.[0]?.message ||
							error.response.data?.errors?.details[0]?.message ||
							error.response.message
					});
				} else {
					setAlert({
						...alert,
						showing: true,
						type: "error",
						message: error.message
					});
				}
			} finally {
				setLoading(false);
			}
		};
		getNewsFeed();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentPage]);

	// Scroll to highlighted card when data loads
	useEffect(() => {
		if (!isDataLoaded || !highlightedId) return;

		const scrollToCard = () => {
			const cardElement = newsCardsRef.current[highlightedId];
			if (!cardElement) return;

			cardElement.scrollIntoView({
				behavior: "smooth",
				block: "center",
				inline: "nearest"
			});

			cardElement.classList.add(style.highlighted);

			const highlightTimer = setTimeout(() => {
				cardElement.classList.remove(style.highlighted);
			}, 5000);

			return () => clearTimeout(highlightTimer);
		};

		const scrollTimer = setTimeout(scrollToCard, 300);
		return () => clearTimeout(scrollTimer);
	}, [highlightedId, isDataLoaded]);

	const handlePageChange = (page) => {
		const params = new URLSearchParams(location.search);
		const highlightId = params.get("highlight");
		const newSearch = `?page=${page}${
			highlightId ? `&highlight=${highlightId}` : ""
		}`;

		// Update both state and URL
		setCurrentPage(page);
		history.push({
			pathname: location.pathname,
			search: newSearch
		});

		const newsSection = document.getElementById("newsSection");
		if (newsSection) {
			newsSection.scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		}

		// Scroll to news section if manually routing by pagination
		setTimeout(() => {
			if (highlightId && newsCardsRef.current[highlightId]) {
				newsCardsRef.current[highlightId].scrollIntoView({
					behavior: "smooth",
					block: "center"
				});
			}
		}, 100);
	};

	return (
		<main>
			{alert.showing && <Alert text={alert.message} type={alert.type} />}
			<NavBar />
			<section className={style.heroSection}>
				<div>
					<h2>News </h2>
					<p>
						Discover the most recent updates on tax-related <br />{" "}
						events unfolding in Enugu State.{" "}
					</p>
				</div>
			</section>
			<section id="newsSection" className={style.enuguTaxNewsHere}>
				{loading ? (
					<div className={style.loadingState}>Loading News...</div>
				) : (
					<>
						<p className={style.desktopsNewsHeading}>
							Stay informed about the latest <br /> tax
							developments and events in Enu
							<span className={style.underlineGreen}>
								gu State
							</span>
						</p>
						<p className={style.mobileNewsHeading}>
							Stay informed about the <br /> latest tax
							developments and
							<br />
							events in Enugu{" "}
							<span className={style.underlineGreen}>State</span>
						</p>
						<div className={style.newsCards}>
							{newsFeed.map((news) => (
								<a
									href={news.NewsLink}
									target="_blank"
									rel="noopener noreferrer"
									key={news.id}
									ref={(el) =>
										(newsCardsRef.current[news.id] = el)
									}
									className={`${style.cardContents} ${
										highlightedId === news.id
											? style.highlighted
											: ""
									}`}
								>
									<img
										src={news.NewsImageLink}
										alt="newsImage"
										className={style.newsImage}
									/>
									<div className={style.newsSource}>
										<img
											src={news.SourceIcon}
											alt="sourceIcon"
										/>
										<h4>{news.NewsHeadline}</h4>
										<p>{news.NewsDescription}</p>
									</div>
								</a>
							))}
						</div>
						<Pagination
							totalPages={totalPages}
							currentPage={currentPage}
							onPageChange={handlePageChange}
						/>
					</>
				)}
			</section>

			<Subscription />
			<Footer />
		</main>
	);
};

export default NewsPage;
